import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import LoginView from "@/views/LoginView.vue";
import BasicLayout from "@/layout/BasicLayout.vue";
import PayView from "@/views/system/PayView.vue";
import CarouselView from "@/views/system/CarouselView.vue";
import TemplateView from "@/views/system/TemplateView.vue";
import MailView from "@/views/system/MailView.vue";
import RechargeView from "@/views/system/RechargeView.vue";
import PostalView from "@/views/system/PostalView.vue";
import SystemView from "@/views/system/SystemView.vue";
import AdminView from "@/views/admin/AdminView.vue";
import AdminUser from "@/views/admin/AdminUser.vue";
import UserAddress from "@/views/admin/UserAddress.vue";
import ProductCategory from "@/views/product/ProductCategory.vue";
import ProductPending from "@/views/product/ProductPending.vue";
import ProductActive from "@/views/product/ProductActive.vue";
import ProductStock from "@/views/product/ProductStock.vue";
import ProductInactive from "@/views/product/ProductInactive.vue";
import JournalView from "@/views/journal/JournalView.vue";
import WithdrawalView from "@/views/order/WithdrawalView.vue";
import OrderPending from "@/views/order/OrderPending.vue";
import SupervisorView from "@/views/system/SupervisorView.vue";
import UserRecharge from "@/views/admin/UserRecharge.vue";
import UserReply from "@/views/admin/UserReply.vue";
import OrderPaid from "@/views/order/OrderPaid.vue";
import OrderProcessed from "@/views/order/OrderProcessed.vue";
import OrderShipped from "@/views/order/OrderShipped.vue";
import HomeView from "@/views/home/HomeView.vue";
import OrderCancelled from "@/views/order/OrderCancelled.vue";

const routes: Array<RouteRecordRaw> = [
  {
    name: "登录界面",
    path: "/login",
    component: LoginView,
  },
  {
    name: "布局",
    path: "/",
    component: BasicLayout,
    meta: {
      require: true,
    },
    children: [
      {
        name: "主页",
        path: "/",
        component: HomeView,
      },
      {
        name: "支付配置",
        path: "/system/pay",
        component: PayView,
      },
      {
        name: "轮播图配置",
        path: "/system/carousel",
        component: CarouselView,
      },
      {
        name: "模版管理",
        path: "/system/template",
        component: TemplateView,
      },
      {
        name: "快递配置",
        path: "/system/mail",
        component: MailView,
      },
      {
        name: "储值活动",
        path: "/system/recharge",
        component: RechargeView,
      },
      {
        name: "邮编配置",
        path: "/system/postal",
        component: PostalView,
      },
      {
        name: "系统配置",
        path: "/system",
        component: SystemView,
      },
      {
        name: "会员管理",
        path: "/admin/user",
        component: AdminUser,
      },
      {
        name: "所有管理员",
        path: "/admin",
        component: AdminView,
      },
      {
        name: "收寄地址",
        path: "/user/address",
        component: UserAddress,
      },
      {
        name: "商品分类",
        path: "/product/category",
        component: ProductCategory,
      },
      {
        name: "商品待审核",
        path: "/product/pending",
        component: ProductPending,
      },
      {
        name: "商品出售中",
        path: "/product/active",
        component: ProductActive,
      },
      {
        name: "商品库存中",
        path: "/product/stock",
        component: ProductStock,
      },
      {
        name: "商品下架",
        path: "/product/inactive",
        component: ProductInactive,
      },
      {
        name: "日记存稿",
        path: "/journal",
        component: JournalView,
      },
      {
        name: "余额提现",
        path: "/order/withdrawal",
        component: WithdrawalView,
      },
      {
        name: "商品订单待支付",
        path: "/order/pending",
        component: OrderPending,
      },
      {
        name: "商品订单已支付",
        path: "/order/paid",
        component: OrderPaid,
      },
      {
        name: "商品订单已制作",
        path: "/order/processed",
        component: OrderProcessed,
      },
      {
        name: "商品订单已寄出",
        path: "/order/shipped",
        component: OrderShipped,
      },
      {
        name: "回收站",
        path: "/order/canceled",
        component: OrderCancelled,
      },
      {
        name: "监所",
        path: "/system/supervisor",
        component: SupervisorView,
      },
      {
        name: "用户储值",
        path: "/user/recharge",
        component: UserRecharge,
      },
      {
        name: "回信管理",
        path: "/user/reply",
        component: UserReply,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
